import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { RequestableTitleList } from "../../components/title/RequestableTitleList";
import { RouteGuard } from "../../guards/RouteGuard";
function RequestableTitles() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(RequestableTitleList, null))); } })));
}
export default RequestableTitles;
